import { useRef, useState } from "react";
import { Check, ChevronDown } from "lucide-react";

export const SearchKeywords = ({ groups, selected, onChange }) => {
  const [openedId, setOpenedId] = useState(null);
  const hold = useRef(null);
  const longPressed = useRef(false);
  const opened = groups.find((group) => group.id === openedId);
  const stopHold = () => { window.clearTimeout(hold.current); hold.current = null; };
  const toggleGroup = (group) => {
    const all = group.keywords.every((word) => selected.includes(word));
    onChange(all ? selected.filter((word) => !group.keywords.includes(word)) : [...new Set([...selected, ...group.keywords])]);
  };
  const toggleTerm = (term) => onChange(selected.includes(term) ? selected.filter((word) => word !== term) : [...selected, term]);
  return <div className="map-keywords" data-testid="map-keywords">
    <span className="section-label">ATTIVITÀ</span>
    <div className="map-keyword-list">{groups.map((group) => {
      const count = group.keywords.filter((word) => selected.includes(word)).length;
      return <div className="group-chip-wrap" key={group.id}>
        <button type="button" className={`keyword-chip group-chip${count ? " active" : ""}`}
          aria-pressed={count === group.keywords.length} aria-label={`${group.id} ${group.name}, ${count} di ${group.keywords.length} selezionate`}
          onPointerDown={() => { longPressed.current = false; hold.current = window.setTimeout(() => { longPressed.current = true; setOpenedId(group.id); }, 500); }}
          onPointerUp={stopHold} onPointerCancel={stopHold} onPointerLeave={stopHold}
          onContextMenu={(e) => { e.preventDefault(); setOpenedId(group.id); }}
          onClick={() => { if (longPressed.current) { longPressed.current = false; return; } toggleGroup(group); }}
          data-testid={`group-chip-${group.id}`}><strong>{group.id}</strong> {group.name}{count > 0 && <small>{count}/{group.keywords.length}</small>}</button>
        <button type="button" className="group-expand" title={`Parole del gruppo ${group.name}`} aria-expanded={openedId === group.id}
          aria-label={`Parole del gruppo ${group.name}`} onClick={() => setOpenedId(openedId === group.id ? null : group.id)}
          data-testid={`group-expand-${group.id}`}><ChevronDown size={17} /></button>
      </div>;
    })}</div>
    {opened && <div className="group-terms-inline" data-testid="group-terms-sheet">
      <strong className="section-label" data-testid="group-terms-title">{opened.id} · {opened.name}</strong>
      <div className="group-term-list">{opened.keywords.map((term, index) => <button type="button" key={term}
        className={`group-term${selected.includes(term) ? " active" : ""}`} aria-pressed={selected.includes(term)}
        onClick={() => toggleTerm(term)} data-testid={`group-term-${opened.id}-${index}`}><span>{term}</span>{selected.includes(term) && <Check size={18} />}</button>)}</div>
      <button type="button" className="text-action" onClick={() => setOpenedId(null)} data-testid="group-terms-done">Chiudi parole</button>
    </div>}
  </div>;
};